import { render } from "./QuestionSign.vue?vue&type=template&id=b672915e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QuestionSign.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b672915e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b672915e', __exports__)) {
    api.reload('b672915e', __exports__)
  }
  
  module.hot.accept("./QuestionSign.vue?vue&type=template&id=b672915e", () => {
    api.rerender('b672915e', render)
  })

}


export default __exports__